import { IFileEntity } from '@/interfaces/IFileEntity';
import { Globals } from '@/modules/Globals';
import axios from 'axios';

const API_URL = `${Globals.apiPath}/files`;
export default class FileService {
  /** `timeoutMs`: give up after that long without an answer (none by default). */
  static async upload(file: File, timeoutMs?: number) {
    const formData = new FormData();
    formData.append('file', file);
    const url = `${API_URL}/upload`;
    const res =
      timeoutMs === undefined
        ? await axios.post<IFileEntity>(url, formData)
        : await axios.post<IFileEntity>(url, formData, { timeout: timeoutMs });
    return res.data;
  }
}
